import api from "@/services/api";

const state = {
  customers: [],
  customerInvoices: [],
};

const mutations = {
  SET_Customers(state, customers) {
    state.customers = customers;
  },
  SET_CustomerInvoices(state, invoices) {
    state.customerInvoices = invoices;
  }
};

const actions = {
  async getCustomers({ commit }) {
    try {
      const res = await api.get("/customers");
      commit("SET_Customers", res.data);
    } catch (error) {
      console.error("Error fetching customers:", error.message);
      throw error;
    }
  },

  async createCustomer({ dispatch }, customerData) {
    try {
      let result = await api.post("/customers", customerData);
      await dispatch("getCustomers");
      return result.data;
    } catch (error) {
      console.error("Error creating customer:", error.message);
      throw error;
    }
  },

  async getCustomerById(_, customerId) {
    try {
      const res = await api.get(`/customers/${customerId}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching customer by ID:", error.message);
      throw error;
    }
  },

  async updateCustomer({ dispatch }, { customerId, customerData }) {
    try {
      await api.put(`/customers/${customerId}`, customerData);
      await dispatch("getCustomers");
    } catch (error) {
      console.error("Error updating customer:", error.message);
      throw error;
    }
  },

  async deleteCustomer({ dispatch }, customerId) {
    try {
      await api.delete(`/customers/${customerId}`);
      await dispatch("getCustomers");
    } catch (error) {
      console.error("Error deleting customer:", error.message);
      throw error;
    }
  },

  async getCustomerInvoices({ commit }, customerId) {
    try {
      const res = await api.get(`/customers/${customerId}/invoices`);
      commit("SET_CustomerInvoices", res.data);
    } catch (error) {
      console.error("Error fetching customer invoices:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};